module.exports = __webpack_public_path__ + "img/sidebar_tamedia.93c731ff.png";